var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 41.5,
    fill: "url(#paint0_linear_65_5990)",
    stroke: "#424242"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6655 30.7155H25.0358V29.3703L54.6299 27.0028V29.3703H58.6655V25.3348C58.6655 22.3753 56.2684 20.2984 53.3412 20.7154L26.3272 24.5734C23.3974 24.9931 21.0002 27.7561 21.0002 30.7155V57.6193C21.0002 59.0463 21.5671 60.4149 22.5762 61.424C23.5853 62.4331 24.9539 63 26.381 63H58.6655C60.0926 63 61.4612 62.4331 62.4703 61.424C63.4793 60.4149 64.0462 59.0463 64.0462 57.6193V36.0963C64.0462 34.6692 63.4793 33.3006 62.4703 32.2915C61.4612 31.2824 60.0926 30.7155 58.6655 30.7155ZM54.6299 49.5643C54.0998 49.5641 53.5749 49.4595 53.0852 49.2565C52.5955 49.0534 52.1505 48.7559 51.7758 48.3809C51.4011 48.006 51.1039 47.5608 50.9011 47.071C50.6984 46.5811 50.5942 46.0562 50.5944 45.526C50.5945 44.9959 50.6991 44.471 50.9022 43.9813C51.1052 43.4916 51.4027 43.0466 51.7777 42.6719C52.1527 42.2972 52.5978 41.9999 53.0877 41.7972C53.5775 41.5945 54.1025 41.4903 54.6326 41.4905C55.7033 41.4908 56.7299 41.9165 57.4868 42.6738C58.2436 43.4311 58.6685 44.4581 58.6682 45.5287C58.6678 46.5994 58.2422 47.626 57.4848 48.3828C56.7275 49.1397 55.7006 49.5646 54.6299 49.5643Z",
    fill: "url(#paint1_linear_65_5990)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_65_5990",
    x1: 42,
    y1: 84,
    x2: 42,
    y2: -4.32905e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_65_5990",
    x1: 21.0002,
    y1: 42.1379,
    x2: 64.0462,
    y2: 42.1379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoAccounts);
export default __webpack_public_path__ + "static/media/icon_no_accounts.8ff6c71772ded250360e758539317402.svg";
export { ForwardRef as ReactComponent };